import React from 'react';
import { Helmet } from 'react-helmet-async';

const BusinessVerification = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Business Verification - CARGO AUTOMOTIVE SERVICES INC | EIN: 83-2229681</title>
        <meta name="description" content="Verified business entity: CARGO AUTOMOTIVE SERVICES INC (DBA: Cargo Engage). EIN: 83-2229681. Address: 306 Schunnemunk Street, Monroe, NY 10950. Owner: Mendel Friedman. A2P registered." />
        <meta name="keywords" content="business verification, CARGO AUTOMOTIVE SERVICES INC, EIN 83-2229681, A2P registration, verified business, Monroe NY" />
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Business Verification</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <h2 style={{color: '#1e40af', marginBottom: '1rem'}}>Verified Business Entity</h2>
              <p>
                Cargo Engage is a verified business entity with complete documentation available for A2P registration, 
                carrier approval processes, and regulatory compliance. We maintain full transparency in our business operations.
              </p>
            </div>

            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem'}}>
              <h3 style={{color: '#1e3c72', marginBottom: '1.5rem', fontSize: '1.5rem'}}>Company Information</h3>
              
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem'}}>
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>Legal Business Name</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>CARGO AUTOMOTIVE SERVICES INC</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>DBA (Doing Business As)</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>Cargo Engage</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>EIN (Tax ID)</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>83-2229681</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>Business Type</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>Lead Generation & Marketing</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>Business Address</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>306 Schunnemunk Street, Monroe, NY 10950</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>Owner</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>Mendel Friedman</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>Industry</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>Financial Services Lead Generation</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#4b5563', marginBottom: '0.5rem'}}>Website</p>
                  <p style={{fontSize: '1.1rem', color: '#1e3c72'}}>cargoengage.com</p>
                </div>
              </div>
            </div>

            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem'}}>
              <h3 style={{color: '#1e3c72', marginBottom: '1.5rem', fontSize: '1.5rem'}}>Business Services</h3>
              <p style={{marginBottom: '1rem', lineHeight: '1.8'}}>
                Cargo Engage provides professional lead generation and marketing services for the financial services industry:
              </p>
              <ul style={{lineHeight: '2', paddingLeft: '2rem', color: '#4b5563'}}>
                <li>Lead generation for financial service providers</li>
                <li>Consumer-to-lender connection services</li>
                <li>SMS and email marketing campaigns</li>
                <li>Lead qualification and verification</li>
                <li>Campaign management and optimization</li>
              </ul>
            </div>

            <div style={{background: '#fff3cd', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #ffc107'}}>
              <h3 style={{color: '#856404', marginBottom: '1rem'}}>Important Disclosure</h3>
              <p style={{color: '#856404', lineHeight: '1.8'}}>
                <strong>Cargo Engage is a lead generation and marketing company.</strong> We are NOT a lender, loan broker, 
                or agent for any lender. We do NOT make credit decisions, extend credit, or determine loan terms. We connect 
                consumers seeking financial services with our network of financial service providers and lending partners.
              </p>
            </div>

            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem'}}>
              <h3 style={{color: '#1e3c72', marginBottom: '1.5rem', fontSize: '1.5rem'}}>Compliance & Certifications</h3>
              
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f8fafc', borderRadius: '8px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>✅</div>
                  <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>TCPA Compliant</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Full compliance with TCPA regulations</p>
                </div>
                
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f8fafc', borderRadius: '8px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>📱</div>
                  <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>A2P Registered</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Carrier-approved messaging</p>
                </div>
                
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f8fafc', borderRadius: '8px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>🔒</div>
                  <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>Data Protected</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Secure data handling practices</p>
                </div>
                
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f8fafc', borderRadius: '8px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>📋</div>
                  <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>CTIA Guidelines</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Industry best practices</p>
                </div>
              </div>
            </div>

            <div style={{background: '#f0fdf4', padding: '2rem', borderRadius: '10px', border: '2px solid #16a34a'}}>
              <h3 style={{color: '#16a34a', marginBottom: '1rem'}}>Verification Status</h3>
              <p style={{color: '#166534', lineHeight: '1.8'}}>
                ✓ Business entity verified<br />
                ✓ EIN confirmed<br />
                ✓ A2P registration complete<br />
                ✓ Compliance documentation on file<br />
                ✓ Carrier approval obtained
              </p>
            </div>

            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <p style={{color: '#6b7280', marginBottom: '1rem'}}>
                For verification inquiries or additional documentation requests:
              </p>
              <p style={{fontSize: '1.1rem', color: '#1e3c72', fontWeight: '600'}}>
                verification@cargoengage.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessVerification;
